export default __webpack_public_path__ + "static/about-us-ae28cbdd7af565191fe0566379355b14.png";